<template>
  <footer>
    <div class="footer-link" v-if="!isAuWallet() || !isCe001()">
      <div class="container -margin">
        <div class="row">
          <div class="col-md-3 col-12">
            <accordion-list>
              <accordion-item class="-heading -link" to="sv002">au PAY スマートローンの特徴</accordion-item>
            </accordion-list>
            <accordion-list>
              <accordion-item class="-heading -toggle" :toggle="true">知っておきたい！ローンについて</accordion-item>
              <accordion-item class="-link -inner" to="sv003">知っておきたい！ローンについて</accordion-item>
              <accordion-item class="-link -inner" to="sv043">いまさら聞けない！ローンの基礎知識</accordion-item>
              <accordion-item class="-link -inner" to="sv042">教えて！みんなのローン活用術</accordion-item>
              <accordion-item class="-link -inner" to="sv044">auサービスでもっとおトクに！</accordion-item>
            </accordion-list>
          </div>
          <div class="col-md-3 col-12">
            <accordion-list>
              <accordion-item class="-heading -toggle" :toggle="true">新規お申し込みについて</accordion-item>
              <accordion-item class="-link -inner" to="sv045">お申し込み条件・お手続きの流れ</accordion-item>
              <accordion-item class="-link -inner" to="sv018">ご利用可能な金融機関</accordion-item>
              <accordion-item class="-link -inner" to="sv019">お申し込みに必要な書類</accordion-item>
              <accordion-item class="-link -inner" to="sv057">収入証明書について</accordion-item>
              <accordion-item class="-link -inner" to="sv021">いくら借りられるの？チェック</accordion-item>
              <accordion-item class="-link -inner" to="sv059">会員さま専用サイト・専用アプリについて</accordion-item>
            </accordion-list>
          </div>
          <div class="col-md-3 col-12">
            <accordion-list>
              <accordion-item class="-heading -toggle" :toggle="true">お借り入れについて</accordion-item>
              <accordion-item class="-link -inner" to="sv046">お借り入れ方法</accordion-item>
              <accordion-item class="-link -inner" to="sv024">au PAY 残高にチャージ</accordion-item>
              <accordion-item class="-link -inner" to="sv023">ご登録口座へのお振込み</accordion-item>
              <accordion-item class="-link -inner" to="sv025">セブン銀行スマホATM</accordion-item>
              <accordion-item class="-link -inner" to="sv022">お利息のご案内</accordion-item>
            </accordion-list>
          </div>
          <div class="col-md-3 col-12">
            <accordion-list>
              <accordion-item class="-heading -toggle" :toggle="true">ご返済について</accordion-item>
              <accordion-item class="-link -inner" to="sv047">ご返済方法</accordion-item>
              <accordion-item class="-link -inner" to="sv026">ご登録口座からのお引落し</accordion-item>
              <accordion-item class="-link -inner" to="sv029">セブン銀行スマホATM</accordion-item>
              <accordion-item class="-link -inner" to="sv027">指定口座へのお振込み</accordion-item>
              <accordion-item class="-link -inner" to="sv052">ご返済シミュレーション</accordion-item>
            </accordion-list>
          </div>
        </div>
      </div>
      <div class="container">
        <ul class="link-box">
          <li class="border">|</li>
          <li class="link"><router-link :to="{name: 'sv030'}">会員規約</router-link></li>
          <li class="border">|</li>
          <li class="link"><a href="https://www.kddi-fs.com/corporate/policy/" target="_blank">プライバシーポリシー</a></li>
          <li class="border">|</li>
          <li class="-pcnone"><br></li>
          <li class="-pcnone border">|</li>
          <li class="link"><a href="https://www.kddi-fs.com/corporate/sitepolicy/" target="_blank">サイトのご利用にあたって</a></li>
          <li class="border">|</li>
          <li class="link"><a href="https://www.kddi-fs.com/corporate/company/" target="_blank">企業情報</a></li>
          <li class="-pcnone border">|</li>
          <li class="-pcnone"><br></li>
          <li class="border">|</li>
          <li class="link"><router-link :to="{name: 'sv036'}">お問い合わせ</router-link></li>
          <li class="border">|</li>
          <li class="link"><router-link :to="{name: 'sv039'}">サイトマップ</router-link></li>
          <li class="border">|</li>
        </ul>
      </div>
    </div>

    <div class="footer-text">
      <div class="container position">
        <div class="box-left">
          <card-header class="_p-0">
            <p class="heading">貸付条件を確認し、借りすぎに注意しましょう。</p>
          </card-header>
          <card-body class="_p-0 _pb-sm-30">
            <p>・貸付利率/2.9％～18.0％（実質年率）※2020年4月28日以前にお申し込みの方は8.0％～18.0％（実質年率）<br>
              ・返済方式/借入時残高スライド元利定額返済方式 <br class="-pcnone">
              ・遅延利率/20.0％（実質年率）<br>
              ・返済回数および返済期間/最長60回（5年）<br class="-pcnone">
              ・担保・保証人/不要・ご利用限度額：1万円～100万円・要審査
            </p>
          </card-body>
          <div class="card-img _mb-sm-30">
            <div class="leftbox">
              <img src="@/assets/images/footer/kashikin1.gif" class="img-fluid _mb-sm-10">
            </div>
            <div class="rightbox">
              <a href="https://www.j-fsa.or.jp/personal/borrowing/diagnosis/" target="_blank">
                <img src="@/assets/images/footer/kashikin2.jpg" class="img-fluid">
              </a>
            </div>
          </div>
        </div>
        <div class="box-right border-box">
          <img src="@/assets/images/footer/kfs_info.gif" class="img-fluid">
        </div>
      </div>
    </div>

    <div class="footer-service">
      <div class="container">
        <div class="position">
          <small>COPYRIGHT © au FINANCIAL SERVICE CORPORATION, ALL RIGHTS RESERVED.</small>

          <div class="footer-logo">
            <div class="logoleft">
              <img src="@/assets/images/footer/kddi_fs_logo.jpg" class="img-fluid">
            </div>
            <div class="logoright">
              <img src="@/assets/images/footer/kddi_group_logo.jpg" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { isAuWallet } from '../../utils/UserAgent'
import CardBox from '../../components/card/CardBox'
import CardHeader from '../../components/card/CardHeader'
import CardBody from '../../components/card/CardBody'
import AccordionList from '../../components/accordion/AccordionList'
import AccordionItem from '../../components/accordion/AccordionItem'
import ListGroup from '../../components/list/ListGroup'
import ListItem from '../../components/list/ListItem'

export default {
  name: 'footer-service',
  components: {
    ListItem,
    ListGroup,
    CardBody,
    CardHeader,
    CardBox,
    AccordionList,
    AccordionItem
  },
  methods: {
    isAuWallet: function () {
      return isAuWallet()
    },
    isCe001: function () {
      return this.$route.name.indexOf('ce001') !== -1
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.footer-link {
  background-color: #f5f5f5;
  padding-bottom: 30px;
  @include mq-up(md) {
    padding-top: 55px;
    padding-bottom: 55px;
  }
  &.mb {
    @include mq-up(md) {
      padding-top: 23px;
      padding-bottom: 23px;
    }
    @include mq-down(md) {
      padding-top: 30px;
      padding-bottom: 30px;
    }
  }
  > .position {
    @include mq-up(md) {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    }
    @include mq-down(md) {
      padding-left: 0;
      padding-right: 0;
    }
  }
  > .-margin {
    margin-bottom: 30px;
    @include mq-up(md) {
      margin-bottom: 70px;
    }
  }
  .link-box {
    @include mq-down(md) {
      text-align: center;
      line-height: 14px;
    }
    .link,.border {
      display: inline-block;
      a {
        font-size: 12px;
        line-height: 14px;
        padding-left: 10px;
        padding-right: 10px;
        @include mq-up(md) {
          padding-left: 20px;
          padding-right: 20px;
          font-size: 14px;
          line-height: 28px;
        }
      }
    }
  }
  >.container {
    >.row {
      >.col-12 {
        @include mq-down(md) {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }
}

.footer-text {
  padding-top: 40px;
  padding-bottom: 40px;
  @include mq-up(md) {
    padding-top: 55px;
    padding-bottom: 55px;
  }
  .position {
    @include mq-up(md) {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    }
  }
  .box-left {
    width: 100%;
    @include mq-up(md) {
      width: 57%;
    }
    .card-img {
      @include mq-up(md) {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      flex-flow: row nowrap;
      }
      .leftbox {
        @include mq-up(md) {
        max-width: 428px;
        width: 100%;
        }
        img {
          @include mq-up(md) {
            width: 100%;
          }
        }
      }
      .rightbox {
        @include mq-up(md) {
        max-width: 230px;
        width: 100%;
        }
        img {
          @include mq-up(md) {
            width: 100%;
          }
        }
      }
    }
    .heading {
      font-size: 14px;
      line-height: 23px;
      @include mq-up(md) {
        font-size: 18px;
        line-height: 42px;
      }
    }
    .card-body {
      p {
        font-size: 10px;
        line-height: 16px;
        @include mq-up(md) {
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }
  .box-right {
    width: 100%;
    @include mq-up(md) {
      width: 37%;
      margin-left: 6%;
    }
    &.border-box {
      padding: 0;
      border: 1px solid $secondary;
      @include mq-up(md) {
        padding: 20px 0;
      }
      >.heading {
        font-size: 14px;
        line-height: 26px;
        text-align: center;
        @include mq-up(md) {
          font-size: 16px;
          line-height: 42px;
        }
      }
      >.position {
        display: flex;
        justify-content: space-between;
        .txt01 {
          font-size: 12px;
          line-height: 24px;
          max-width: 82%;
          float: left;
          @include mq-up(md) {
            max-width: 80%;
            font-size: 14px;
            line-height: 20px;
          }
        }
        .imgbox {
          max-width: 18%;
          @include mq-up(md) {
          max-width: 20%;
          float: right;
          }
        }
      }
    }
  }
}

.footer-service {
  border-top: 1px solid $secondary;
  padding: 30px 0;
  @include mq-up(md) {
    margin-top: 30px;
  }
  @include mq-down(md) {
    padding-top: 15px;
    padding-bottom: 10px;
  }
  .position {
    @include mq-up(md) {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-flow: row nowrap;
    }
  }
  small {
    font-size: 10px;
    @include mq-down(md) {
      display: inline-block;
      text-align: center;
    }
    @include mq-up(md) {
      font-size: 12px;
    }
  }

  .footer-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    @include mq-up(md) {
      justify-content: flex-end;
    }
    .logoleft {
      max-width: 120px;
      @include mq-up(md) {
        max-width: 160px;
        width: 100%;
      }
    }
    .logoright {
      max-width: 68px;
      margin-left: 20px;
      @include mq-up(md) {
        max-width: 80px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/globals/FooterService.vue